mutation AddEventMember(
  $eventId: ID!
  $email: String!
  $role: StreamToolsEventMemberRole
) {
  member: StreamToolsAddEventMember(eventId: $eventId, email: $email, role: $role) {
    eventId
    userId
    email
    displayName
    role
    addedBy
    addedAt
  }
}
